<div class="padding_20">
  <app-data-grid [dataGridSettings]="dataGridSettings" [booleanParam]="isEmployee">
  </app-data-grid>
</div>

